const normalizeAppNameKey = (key) => typeof key === 'string'
  ? key.trim().toLowerCase().replace(/[^a-z0-9]/g, '')
  : '';

export const APP_NAME_KEYS = new Set([
  'applicationname',
  'applicationclientname',
  'appname',
  'applicationdisplayname',
  'appdisplayname',
  'requestname',
  'businessapplication',
  'businessappname',
  'businessapp',
  'application_name',
  'application_client_name',
  'business_application',
  'business_app_name',
]);

const normalizeAppNameCandidate = (value) => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || '';
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    const trimmed = String(value).trim();
    return trimmed || '';
  }

  return '';
};

const collectAppNameCandidates = (node, found = []) => {
  if (!node || typeof node === 'function') return found;

  if (Array.isArray(node)) {
    node.forEach((entry) => collectAppNameCandidates(entry, found));
    return found;
  }

  if (typeof node !== 'object') return found;

  Object.entries(node).forEach(([key, value]) => {
    if (APP_NAME_KEYS.has(normalizeAppNameKey(key))) {
      const normalized = normalizeAppNameCandidate(value);
      if (normalized) found.push(normalized);
    }

    if (value && typeof value === 'object') {
      collectAppNameCandidates(value, found);
    }
  });

  return found;
};

export const resolveApplicationName = (item) => {
  const prioritySources = [
    item?.applicationName,
    item?.applicationClientName,
    item?.appName,
    item?.app_name,
    item?.application_name,
    item?.application_client_name,
    item?.requestName,
    item?.requestDetails?.displayFields?.['Application Name'],
    item?.requestDetails?.displayFields?.applicationName,
    item?.requestDetails?.displayFields?.applicationClientName,
    item?.requestDetails?.displayFields?.appName,
    item?.requestDetails?.displayFields?.app_name,
    item?.requestDetails?.rawRequest?.request?.applicationName,
    item?.requestDetails?.rawRequest?.request?.['Application Name'],
    item?.requestDetails?.rawRequest?.request?.applicationClientName,
    item?.requestDetails?.rawRequest?.request?.appName,
    item?.requestDetails?.rawRequest?.request?.app_name,
    item?.requestDetails?.rawRequest?.applicationName,
    item?.requestDetails?.rawRequest?.['Application Name'],
    item?.requestDetails?.rawRequest?.applicationClientName,
    item?.requestDetails?.rawRequest?.appName,
    item?.requestDetails?.rawRequest?.app_name,
    item?.requestDetails?.request?.applicationName,
    item?.requestDetails?.request?.['Application Name'],
    item?.requestDetails?.request?.applicationClientName,
    item?.requestDetails?.request?.appName,
    item?.requestDetails?.request?.app_name,
    item?.businessApplication,
    item?.businessAppName,
    item?.requestDetails?.displayFields?.businessApplication,
    item?.requestDetails?.displayFields?.businessAppName,
    item?.requestDetails?.rawRequest?.request?.businessAppName,
    item?.requestDetails?.rawRequest?.request?.businessApplication,
    item?.requestDetails?.rawRequest?.businessAppName,
    item?.requestDetails?.rawRequest?.businessApplication,
    item?.requestDetails?.request?.businessAppName,
    item?.requestDetails?.request?.businessApplication,
  ];

  const candidate = [...prioritySources, ...collectAppNameCandidates(item)].find((value) => {
    if (typeof value === 'string') return value.trim().length > 0;
    return value !== undefined && value !== null && value !== '';
  });

  return typeof candidate === 'string' ? candidate.trim() : (candidate ? String(candidate).trim() : '');
};

export default resolveApplicationName;
